<script lang='ts'>
import { from } from "rxjs";

import type { Badge } from "../services";
import { markdown } from "../util";
import { quintOut, bounceOut, backOut } from 'svelte/easing';
import { tick } from "svelte";

export let badge: Badge;

let loader;
let ready = false;
let nextBadge;

function slideOpen(node, options) {
  const height = node.clientHeight;
  const restHeight = 234;
  return {
    duration: 2000,
    css: t => {
      let outHeight;
      if (t < 0.8) outHeight = restHeight * quintOut((Math.min(0.2, t) / 0.2));
      else outHeight = ((t - 0.8) / 0.2) * (height - restHeight) + restHeight;
      return `height: ${outHeight}px`;
    }
  };
}

function imageIn(node, options) {
  return {
    duration: 1000,
    delay: 500,
    css: t => `transform: scale(${bounceOut(t)})`
  }
}

function preloadImage(src) {
  return from(new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = resolve
    image.onerror = reject
    image.src = src
  }));
}

async function load() {
  ready = false;
  await tick();
  loader?.unsubscribe();
  loader = preloadImage(badge.image).subscribe(() => ready = true);
}

$: if (badge) load();
</script>

<div class="modal" on:click>
  {#if ready}
  <audio autoplay style="display:none">
    <source src="/sound/win{Math.random() > 0.5 ? '1' : '2'}.mp3" type="audio/mpeg">
  </audio>
  <div class="box col hcenter shadow" on:click|stopPropagation in:slideOpen>
    <!-- svelte-ignore a11y-missing-attribute -->
    <img class='img' src={badge.image} in:imageIn />

    <div class='pad col hcenter'>
      {#if badge.done}
        <div class='complete'>COMPLETED</div>
      {/if}
      <div class='name'>{badge.name}</div>
      <div class='desc'>{@html markdown(badge.done ? badge.unlocked_description : badge.locked_description)}</div>

      <div class='points-container row vcenter' style='margin-bottom: 16px'>
        {badge.points}
        <!-- svelte-ignore a11y-missing-attribute -->
        <img src="/img/point.png" />
      </div>

      {#if !badge.done}
        <div class='progress-text'><span style="color: red">{badge.progress[0]}</span> of {badge.progress[1]}</div>
        <div class="bar">
          <div class="inner-bar" style="width: {Math.floor(badge.progress[0] / badge.progress[1] * 100)}%" />
        </div>
      {:else if badge.link}
        <div class='button' on:click={() => window.open(badge.link, '_blank')}>LEARN MORE</div>
      {/if}
    </div>

    {#if !badge.done}
      <div class='col vcenter hcenter completion'>
        <div class='clabel'>UPON COMPLETION</div>
        <div class='points-container row vcenter'>
          {badge.points}
          <!-- svelte-ignore a11y-missing-attribute -->
          <img src="/img/point.png" />
        </div>
      </div>
    {/if}
  </div>
  {/if}
</div>

<style>
.anchor {
  position: fixed;
  /* top: 70%; */
  left: 50%;
  /* transform: translateX(-50%); */
  /* bottom: 30%; */
  z-index: 123;
}

.img {
  margin: 32px;
  height: 170px;
  transform-origin: center center;
  /* animation: img_in 500ms linear 500ms forwards;
  transform: scale(0); */
}

.completion {
  height: 60px;
  background-color: #F3F3F3;
  width: 100%;
  border-top: 1px solid #0000004d;
}

.clabel {
  font-size: 12px;
}

.name {
  margin-top: 16px;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.complete {
  font-weight: bold;
  text-align: center;
  font-size: 20px;
}

.desc {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
}
.progress-text {
  font-size: 40px;
  font-weight: bold;
}

.points-container {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 8px;
}

.points-container img {
  margin-left: 8px;
}

.box {
  position: absolute;
  width: 300px;
  z-index: 123;
  background-color: white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  overflow: hidden;
}

.pad {
  padding: 0 32px 32px 32px;
  animation: textSlide 500ms linear 1.8s forwards;
  opacity: 0;
}

@keyframes textSlide {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.bar {
  position: relative;
  height: 24px;
  width: 100%;
  background-color: grey;
  overflow: hidden;
  border-radius: 4px;
}

.inner-bar {
  height: 100%;
  background-color: red;
  transition: width 1450ms;
}
</style>